var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, DrawerBody, DrawerFooter, Typography, } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import React from 'react';
import { SubmitDeliveryAddressCreateCart } from '../../../api/oms/edit-delivery-address';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { useExperienceContext, useFulfillmentGroupContext, useEditDeliveryAddressContext, useOrderContext, useEditDeliveryInstructionsContext, } from '../../../hooks/useContexts';
import '../../../styles/drawer.scss';
import { getWindow } from '../../../utils/general';
import { AlertBanner } from '../../shared/alert-banner/AlertBanner';
import { BodfsDeliveryDetails } from './BodfsDeliveryAddress/BodfsDeliveryDetails';
import { newDeliveryAddress } from './EditDeliveryAddressNewDeliveryAddress';
import { pickupItemImages } from './EditDeliveryAddressPickupItemImages';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
export var EditDeliveryAddressDeliveryDetails = function (_a) {
    var _b, _c, _d, _e, _f;
    var updatedAddressData = _a.updatedAddressData, newDeliveryAddressDetails = _a.newDeliveryAddressDetails, setIsChangeForm = _a.setIsChangeForm, setIsConfirmation = _a.setIsConfirmation, setIsDeliveryDetails = _a.setIsDeliveryDetails, isDeliveryDetails = _a.isDeliveryDetails, suspendCartCheck = _a.suspendCartCheck, setIsLoading = _a.setIsLoading, setIsExcludedAddress = _a.setIsExcludedAddress, setIsValidated = _a.setIsValidated, closeDrawer = _a.closeDrawer, setUpdatedAddressData = _a.setUpdatedAddressData, setEditDeliveryAddressAlert = _a.setEditDeliveryAddressAlert, traceId = _a.traceId, deliveryAddressCreateCartRequestData = _a.deliveryAddressCreateCartRequestData, resetBodfsFlow = _a.resetBodfsFlow, selectedDeliveryOptionType = _a.selectedDeliveryOptionType;
    var _g = useFulfillmentGroupContext(), fulfillmentGroup = _g.fulfillmentGroup, fulfillmentGroupIndex = _g.fulfillmentGroupIndex;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _h = useEditDeliveryAddressContext(), availableDeliverySlotsResponse = _h.availableDeliverySlotsResponse, selectedDateId = _h.selectedDateId, requireSignature = _h.requireSignature;
    var _j = useOrderContext(), setExcludedShipStateApiError = _j.setExcludedShipStateApiError, setShowDrawerError = _j.setShowDrawerError;
    var deliveryInstructions = useEditDeliveryInstructionsContext().deliveryInstructions;
    var isBODFS = (selectedDeliveryOptionType !== null && selectedDeliveryOptionType !== void 0 ? selectedDeliveryOptionType : fulfillmentGroup.fulfillmentType) ===
        FULFILLMENT_TYPE.BODFS;
    var isIos = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var deliveryCharge = (_f = (_e = (_d = (_c = updatedAddressData === null || updatedAddressData === void 0 ? void 0 : updatedAddressData.ordersInfo) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.newOrder) === null || _e === void 0 ? void 0 : _e.totals) === null || _f === void 0 ? void 0 : _f.deliveryCharge;
    var renderDeliveryDetailsContent = function () {
        if (isBODFS) {
            return React.createElement(BodfsDeliveryDetails, null);
        }
        // cart has been created when isBODFS is false
        if (updatedAddressData) {
            return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-6" },
                newDeliveryAddress(newDeliveryAddressDetails, suspendCartCheck, setIsChangeForm, undefined, setIsDeliveryDetails, resetBodfsFlow),
                React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-6" },
                    React.createElement(AlertBanner, { status: "info" },
                        React.createElement("div", { className: "sui-flex sui-space-x-1" },
                            React.createElement(Typography, { weight: "bold" }, "Your Delivery Cost:"),
                            deliveryCharge && deliveryCharge !== '0.00' ? (React.createElement(Typography, { weight: "bold" },
                                "$",
                                deliveryCharge)) : (React.createElement(Typography, { color: "success", weight: "bold" }, "FREE")))),
                    pickupItemImages(fulfillmentGroup, updatedAddressData, isDeliveryDetails))));
        }
        // arrow function needs to return something
        return null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerBody, null, renderDeliveryDetailsContent()),
        React.createElement(DrawerFooter, null,
            React.createElement("div", { className: "card-fix sui-pb-2" },
                React.createElement(Button, { "data-testid": "continue-button", onClick: function () {
                        var _a;
                        if (isBODFS) {
                            var bodfsFulfillmentTypeCode = ((_a = convertedFulfillmentTypes(FULFILLMENT_TYPE.BODFS)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || undefined;
                            SubmitDeliveryAddressCreateCart({
                                requestData: __assign(__assign({}, deliveryAddressCreateCartRequestData), (isBODFS && {
                                    fulfillmentType: bodfsFulfillmentTypeCode,
                                    originalFulfillmentType: bodfsFulfillmentTypeCode,
                                    slotId: selectedDateId,
                                    etAvailableDeliverySlotsResponse: availableDeliverySlotsResponse === null || availableDeliverySlotsResponse === void 0 ? void 0 : availableDeliverySlotsResponse.et,
                                    newDeliveryInstructions: deliveryInstructions || '',
                                    isSignatureRequired: requireSignature,
                                })),
                                setIsChangeForm: setIsChangeForm,
                                setIsDeliveryDetails: setIsDeliveryDetails,
                                setIsLoading: setIsLoading,
                                setShowDrawerError: setShowDrawerError,
                                setExcludedShipStateApiError: setExcludedShipStateApiError,
                                setIsExcludedAddress: setIsExcludedAddress,
                                setIsValidated: setIsValidated,
                                fulfillmentGroupIndex: fulfillmentGroupIndex,
                                fulfillmentGroup: fulfillmentGroup,
                                closeDrawer: closeDrawer,
                                setUpdatedAddressData: setUpdatedAddressData,
                                setEditDeliveryAddressAlert: setEditDeliveryAddressAlert,
                                traceId: traceId,
                                setIsConfirmation: setIsConfirmation,
                            });
                        }
                        else {
                            setIsConfirmation(true);
                            setIsDeliveryDetails(false);
                        }
                    } }, "Continue")),
            React.createElement("div", { className: classNames('card-fix', {
                    'ios-bottom-fix': isIosMobile,
                }) },
                React.createElement(Button, { variant: "secondary", onClick: function () { return closeDrawer(); } }, "Cancel")))));
};
